module.exports = "<div class=\"container\">\n  <div class=\"item-container\" *ngFor=\"let documents of documentsStep; let i = index\">\n    <div class=\"item\">\n      <div class=\"dot\" [ngClass]=\"{'selected': i == active}\"></div>\n      <div class=\"type\"> {{ documents }}</div>\n    </div>\n    <div *ngIf=\"documentsStep[i + 1]\" class=\"divider\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal-documentos/modal-step/modal-step.component.html
// module id = ./src/app/components/modal-documentos/modal-step/modal-step.component.html
// module chunks = main